export default __webpack_public_path__ + "divvy_logo.png";